const getRedirectURL = () => {
  const queryString = window.location.search
  if (!queryString) {
    return
  }

  const urlParams = new URLSearchParams(queryString)
  const leaveQuery = urlParams.get('redirect')?.toLowerCase()
  if (leaveQuery && leaveQuery.includes('n')) {
    return
  }

  let returnQuery = urlParams.get('returnTo')?.toLowerCase()
  if (!returnQuery) {
    returnQuery = urlParams.get('r')?.toLowerCase()
  }
  if (returnQuery) {
    if (returnQuery.includes('http')) {
      // Assuming this is a full URL/UCI
      return decodeURIComponent(returnQuery)
    } else if (returnQuery.includes(':')) {
      // This is probably localhost because it includes a port
      return `//${returnQuery}/`
    } else if (returnQuery.includes('.') || returnQuery.includes('/')) {
      // Assuming this is also a full URL/URI but without a protocol
      return `https://${returnQuery}/`
    } else {
      // Assuming this is a subdomain of firialabs.com
      return `https://${returnQuery}.firialabs.com/`
    }
  }
}

const handleLoginPortalRedirect = () => {
  const redirectURL = getRedirectURL()
  if (redirectURL) {
    window.location.href = redirectURL
  }
}

export default handleLoginPortalRedirect